import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewIssueDialogCommand} from "../open-new-issue-dialog.command";
import {IssueRepository} from "../../domain/repositories/issue.repository";
import {UiHelper} from "../../helpers/ui.helper";
import {Issue} from "../../domain/entities/issue.entity";
import {AbstractCommand} from "../abstract.command";

@CommandHandler(OpenNewIssueDialogCommand)
@singleton()
export class OpenNewIssueDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const issueRepository = container.resolve(IssueRepository);
        const newIssue = await issueRepository.create();
        
        UiHelper.openDialogEntityEdit<AbstractCommand<Issue>>(
            Issue,
            newIssue,
            {
                creationMode: true,
                closable: true
            }
        );
    }
}